<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Renommer un document</p>
		</header>
		<section class="modal-card-body">
			<b-field label="Nom du document" :type="form.errors.has('name') ? 'is-danger' : ''" :message="form.errors.first('name')">
                <b-input type="text" v-model="form.name" placeholder="Mon fichier" maxlength="100" has-counter></b-input>
			</b-field>
		</section>
		<footer class="modal-card-foot">
			<button class="button is-primary" @click="submit()" :disabled="form.processing">
				<i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
				&nbsp;
				<span>Enregistrer</span>
			</button>
			<button class="button" type="button" @click="$parent.close()">Annuler</button>
		</footer>
	</div>
</template>

<script>
	import Form from 'form-backend-validation';

	export default {

        props: ['media'],

    	data() {
        	return {
            	form: new Form({
                	name: ''
            }),
        }
    },
    
    methods: {

        submit() {

			this.form.patch('/api/v1/medias/' + this.media.id, {
                'name': this.form.name
            })
			    .then( response => {
					this.$buefy.toast.open({
                        message: 'Le nom du document a été modifié.',
                        type: 'is-success'
                    });

                    Bus.$emit('event.fetch');
                    this.$parent.close();

                }).catch( response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
        },
    },

    created() {
        this.form.populate({
            name: this.media.name
        });
    }
}
</script>

<style>
</style>
